export default "__VITE_ASSET__C_YfK_48__"